import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

const Search = ({ id, handleChange, search, sx }) => (
  <TextField id={id} label="Rechercher" type="search" size="small" value={search} sx={sx} onChange={handleChange} />
);

Search.propTypes = {
  id: PropTypes.string,
  handleChange: PropTypes.func,
  search: PropTypes.string,
  sx: PropTypes.object
};

export default Search;
